import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import colors from 'seagull/foundations/colors.module.scss';
import { ArrowsHorizontal } from 'seagull/icons/arrows';
const iconColors = {
    error: colors.red970,
    success: colors.green900,
    pending: colors.dark500
};
export const AccountingMappingIcon = (props)=>{
    const { size = 16, intent = 'success', testId, className, style } = props;
    return /*#__PURE__*/ _jsx(ArrowsHorizontal, {
        size: size,
        testId: testId || "accounting-mapping-icon-".concat(intent),
        className: className,
        style: _object_spread_props(_object_spread({}, style), {
            color: iconColors[intent]
        })
    });
};
